const stripe = {
  title: 'Stripe',

  billing_unavailable:
    'Billing is not available for this dealer yet. Please contact support.',

  sync: {
    explanation:
      'This button allows you to start a synchronization to update the number of billable doors in Stripe.',
    button: 'Start a synchronization',
  },
};

export default stripe;
